export default function FormFieldText({ formUtility, field, label, description, className, classNameControl, min, max, placeholder, isPassword = false, disabled = false }) {
    return (
        <div className={className ?? "form-group"}>
            {label?.toString()?.trim().length > 0 ? <label>{label.toString().trim()}</label> : null}
            <input
                name={field}
                value={formUtility.getFieldValue(field)}
                onChange={formUtility.handleChangeControl}
                readOnly={formUtility.fieldsDisabled || disabled}
                disabled={formUtility.fieldsDisabled || disabled}
                minlength={min}
                maxlength={max}
                placeholder={placeholder}
                type={isPassword ? "password" : "text"}
                className={classNameControl ?? "form-control"} />
            {description?.toString()?.trim().length > 0 ? <p>{description.toString().trim()}</p> : <br />}
        </div>
    );
}